export const indicatorGroupReports = {
  "indicatorGroupReports.indicatorGroup.create":
    "indicatorGroupReports.indicatorGroup.create",
  "indicatorGroupReports.indicatorGroup.get":
    "indicatorGroupReports.indicatorGroup.get",
  "indicatorGroupReports.indicatorGroup.edit":
    "indicatorGroupReports.indicatorGroup.edit",
  "indicatorGroupReports.indicatorGroup.delete":
    "indicatorGroupReports.indicatorGroup.delete",
  "indicatorGroupReports.indicatorGroup.restore":
    "indicatorGroupReports.indicatorGroup.restore",
  "indicatorGroupReports.indicatorReport.create":
    "indicatorGroupReports.indicatorReport.create",
  "indicatorGroupReports.indicatorReport.get":
    "indicatorGroupReports.indicatorReport.get",
  "indicatorGroupReports.indicatorReport.edit":
    "indicatorGroupReports.indicatorReport.edit",
  "indicatorGroupReports.indicatorReport.delete":
    "indicatorGroupReports.indicatorReport.delete",
  "indicatorGroupReports.indicatorReport.restore":
    "indicatorGroupReports.indicatorReport.restore",
  "indicatorGroupReports.indicatorReport.addIndicators":
    "indicatorGroupReports.indicatorReport.addIndicators",
  "indicatorGroupReports.indicatorReport.deleteIndicators":
    "indicatorGroupReports.indicatorReport.deleteIndicators",
  "indicatorGroupReports.indicatorReport.upsertDealerFields":
    "indicatorGroupReports.indicatorReport.upsertDealerFields",
  "indicatorGroupReports.report.getDealerIndicatorValues":
    "indicatorGroupReports.report.getDealerIndicatorValues",
  "indicatorGroupReports.report.getDealerIndicatorValuesFile":
    "indicatorGroupReports.report.getDealerIndicatorValuesFile",
} as const;
